import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import Button from 'modules/_shared/components/Buttons';

import { useDocumentsList } from './context/DocumentsListPageContext';
import { documentsListMap } from './constants/documentsListMap';
import NoDocuments from '../NoDocuments';
import UploadDocuments from '../UploadDocuments';

import './DocumentsList.scss';

const DocumentsList: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDocumentsList();

  const hasDocuments = data.documents && data.documents.length > 0;
  const ListComponent =
    data.section &&
    documentsListMap[data.section as keyof typeof documentsListMap];
  const showPagination = data.totalDocuments > 10;

  return (
    <>
      <div className="doc-list">
        <div className="doc-list__header">
          <span className="doc-list__title">{t('Documents')}</span>
          <span className="doc-list__count">{data.totalDocuments}</span>
          <Button
            variant="light"
            onClick={actions.handleAddDocument}
            icon="plus"
            className="ml-auto"
          >
            {t('AddDocument')}
          </Button>
        </div>

        <div className="doc-list__upload">
          <UploadDocuments uploadFiles={actions.handleUploadFiles} />
        </div>

        {ListComponent && hasDocuments ? <ListComponent /> : <NoDocuments />}
      </div>

      {showPagination && (
        <TablePagination
          totalRows={data.totalDocuments || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeItemsPerPage}
        />
      )}
    </>
  );
};

export default DocumentsList;
